import { computed, inject, Injectable } from '@angular/core';
import { Footer } from '@components/footer/models';
import { Header, HeaderSubMenu } from '@components/header/models';
import { SlugPage } from '@pages/slug-page/models';
import { CommonStore } from '@stores';
import { StoreBase } from '@stores/abstract';

@Injectable({ providedIn: 'root' })
export class PageStore extends StoreBase<SlugPage> {
  override storeName = 'PageStore';
  readonly commonStoreMenu = inject(CommonStore);
  readonly header = computed(() => {
    const id = this.selectPath((state) => state.config.header.id);
    const menus = this.commonStoreMenu.select('menus');
    if (!id() || !menus()) return;
    const header = menus()!.find((item) => item.id === id());
    if (header) {
      this.logs.debug(`💽 ${this.storeName}`, `Header found (${header.id})`);
      return header.data as Header;
    } else {
      this.logs.error(
        `💽 ${this.storeName}`,
        `Header not found for the specified ID (${id() ?? 'undefined'})`,
        menus()
      );
      return undefined;
    }
  });
  readonly headerSubMenu = computed(() => {
    const id = this.selectPath((state) => state.config.header.subMenuId);
    const menus = this.commonStoreMenu.select('menus');
    if (!id() || !menus()) return;
    const subMenu = menus()!.find((item) => item.id === id());
    if (subMenu) {
      this.logs.debug(`💽 ${this.storeName}`, `Header SubMenu found (${subMenu.id})`);
      return subMenu.data as HeaderSubMenu;
    } else {
      this.logs.error(
        `💽 ${this.storeName}`,
        `Header SubMenu not found for the specified ID (${id() ?? 'undefined'})`,
        menus()
      );
      return undefined;
    }
  });
  readonly footer = computed(() => {
    const id = this.selectPath((state) => state.config.footer.id);
    const menus = this.commonStoreMenu.select('menus');
    if (!id() || !menus()) return;
    const footer = menus()!.find((item) => item.id === id());
    if (footer) {
      this.logs.debug(`💽 ${this.storeName}`, `Footer found (${footer.id})`);
      return footer.data as Footer;
    } else {
      this.logs.error(
        `💽 ${this.storeName}`,
        `Footer not found for the specified ID (${id() ?? 'undefined'})`,
        menus()
      );
      return undefined;
    }
  });
}
